'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { Bar, Progress, AppProgressProvider as ProgressProvider } from '@bprogress/next';
export type PageNavigationIndicatorProps = {
  children?: ReactNode;
};
export function PageNavigationIndicator(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      showSpinner: true,
      template: null
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Progress className="fixed top-[2px] overflow-hidden inset-x-2 rounded-lg  !bg-white opacity-40 !h-1 !w-auto"><Bar className="!absolute z-[9999] !bottom-0 !top-auto !bg-black opacity-90 !h-1" /></Progress>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <ProgressProvider options={t1} delay={500} shallowRouting={true}>{t2}{children}</ProgressProvider>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}